import { CardActions,Grid,Cell,Button,Card, CardTitle, CardText} from 'react-md';
import MathJax from '../../components/react-mathjax-preview';
import React, { Component } from 'react';


export default class FeedbackPopup extends Component {


   constructor(props){
    super(props)
    this.state = {
      
    }
    this.closeClick = this.closeClick.bind(this);
    console.debug("feedback ",this.props.feedback)
   }
   closeClick(){
    this.props.closeClick();
  }
 /* convertToHTML(text){
    let retVal = "";
    try{
      retVal = TextEditor.getHTMLStringFromEditorState(
        EditorState.createWithContent(convertFromRaw(JSON.parse(text) ))).toString('html',null);
    }
    catch(err){
      console.error(err.message);
    }
    return retVal;
  }*/
   render() {
    let floatFooter = {
      position: 'fixed',
      bottom: '0px',
      width: '100%',
      backgroundColor: 'white',
      float: 'left',
      zIndex: '1',
    };
  
  return (

       <Grid
       visible={this.props.visibility} id="1"
      
       >
       <Cell size={6}>
         <Card
         style = {{ width : '320px',height : '320px',overflow:'auto',position:'fixed',
        bottom:'59px',right: '30%'}}><br/>
            <CardTitle style={{textAlign:"centered", backgroundColor:"white",width:"100%",fontSize: "25px"}}>
              Feedback on your Answer
            </CardTitle>
            <CardText><MathJax math={(this.props.feedback)}/>
            </CardText>
           <div style = {{width:"100%"}}>
                      <CardActions centered>
                      <Button flat secondary style={{ position: 'fixed',
                        bottom: '65px', backgroundColor:'red'}}
                      swapTheming onClick={this.closeClick}>
                      Close
                      </Button>
                      </CardActions>
            </div>
            </Card>
            </Cell>
        </Grid>
        

        );
    }
}
